import { initSentry, captureError } from '../../commons/sentry';
// for all pages
import sidebar from './layout/sidebar';

// // for pages
import users from './users';
import connectivities from './answers/connectivities';
import slots from './answers/slots';
import offers from './offers';
import Rails from '@rails/ujs';

document.addEventListener('DOMContentLoaded', () => {
  initSentry();

  try {
    sidebar();
    slots();
    users();
    connectivities();
    offers();
  } catch (err) {
    captureError(err);
    throw err;
  }

});

Rails.start();
